
/**
 * Deletes select options from the element
 * @param select HTML select element to clear options for
 * @param start Index to start deleting of the options from
 */
export const clearSelectOptions = (select: HTMLSelectElement, start = 0) => {
  const length = select.options.length;
  for (let i = length - 1; i >= start; i--) {
    select.options[i] = null;
  }
};
